var _slicedToArray = require("/home/peopleman2_dev/peopleman2/shared/frontend/app/node_modules/@babel/runtime/helpers/slicedToArray");

var WOMAN_F_VS_L_SUFFIXES = require('./woman_first_vs_last_name_suffixes.json');

var MAN_VS_WOMAN_SUFFIXES = require('./man_vs_woman_suffixes.json');

var MAN_SUFFIXES = require('./man_suffixes.json');

function _getMatchingSuffix(name, suffixes) {
  var search;

  for (var start = name.length; start > 0; start--) {
    search = name.substr(-start);

    if (typeof suffixes[search] === 'string') {
      return [search, suffixes[search]];
    }
  }

  return ['', suffixes[''] || ''];
}

function _vokativWomanFirstName(name) {
  if (name.substr(-1, 1) === 'a') {
    return name.substr(0, name.length - 1) + 'o';
  } else {
    return name;
  }
}

function _vokativWomanLastName(name) {
  return name;
}

function _vokativMan(name) {
  var _getMatchingSuffix2 = _getMatchingSuffix(name, MAN_SUFFIXES),
      _getMatchingSuffix3 = _slicedToArray(_getMatchingSuffix2, 2),
      search = _getMatchingSuffix3[0],
      suffix = _getMatchingSuffix3[1];

  var ret = name.substr(0, name.length - search.length); // name = name[:-len(suffix)] if suffix else name

  return "".concat(ret).concat(suffix);
}
/**
 *
 *
 * @param {string} nameString
 * @returns {boolean}
 */


function isWoman(nameString) {
  var name = nameString.toLowerCase();
  return _getMatchingSuffix(name, MAN_VS_WOMAN_SUFFIXES)[1] === 'w';
}
/**
 *
 *
 * @param {string} nameString
 * @param {boolean} [woman=false]
 * @param {boolean} [lastName=null]
 *
 */


function vokativ(nameString) {
  var womanBool = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var lastName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var name = nameString.toLowerCase();
  var woman = womanBool;

  if (woman === null) {
    woman = isWoman(name);
  }

  if (woman) {
    if (lastName === null) {
      lastName = (_getMatchingSuffix(name, WOMAN_F_VS_L_SUFFIXES)[1] || 'l') === 'l';
    }

    if (lastName) {
      return _vokativWomanLastName(name);
    } else {
      return _vokativWomanFirstName(name);
    }
  } else {
    return _vokativMan(name);
  }
}

module.exports = {
  vokativ: vokativ,
  isWoman: isWoman
};